/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root';
import { Route as AppRouteImport } from './routes/_app';
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password';
import { Route as InvitationRouteImport } from './routes/invitation';
import { Route as LoginRouteImport } from './routes/login';
import { Route as ResetRouteImport } from './routes/reset';
import { Route as ResetPasswordRouteImport } from './routes/reset-password';
import { Route as AppIndexRouteImport } from './routes/_app/index';
import { Route as AppCalendarRouteImport } from './routes/_app/calendar';
import { Route as AppMeRouteImport } from './routes/_app/me';
import { Route as AppModuleUnavailableRouteImport } from './routes/_app/module-unavailable';
import { Route as AppSetupRouteImport } from './routes/_app/setup';
import { Route as AppTasksRouteImport } from './routes/_app/tasks';
import { Route as DevUiRouteImport } from './routes/dev/ui';
import { Route as InviteTokenRouteImport } from './routes/invite.$token';
import { Route as AppAdminAuditRouteImport } from './routes/_app/admin/audit';
import { Route as AppAdminRolesRouteImport } from './routes/_app/admin/roles';
import { Route as AppAdminSettingsRouteImport } from './routes/_app/admin/settings';
import { Route as AppAdminSupportRouteImport } from './routes/_app/admin/support';
import { Route as AppAdminTaxesRouteImport } from './routes/_app/admin/taxes';
import { Route as AppAnalyticsIndexRouteImport } from './routes/_app/analytics/index';
import { Route as AppAnalyticsSalesRouteImport } from './routes/_app/analytics/sales';
import { Route as AppAnalyticsStockRouteImport } from './routes/_app/analytics/stock';
import { Route as AppCrmIndexRouteImport } from './routes/_app/crm/index';
import { Route as AppCrmDuplicatesRouteImport } from './routes/_app/crm/duplicates';
import { Route as AppCrmFollowUpsRouteImport } from './routes/_app/crm/follow-ups';
import { Route as AppCrmLoyaltyRouteImport } from './routes/_app/crm/loyalty';
import { Route as AppCrmSegmentsRouteImport } from './routes/_app/crm/segments';
import { Route as AppCrmSettingsRouteImport } from './routes/_app/crm/settings';
import { Route as AppCustomersCustomerIdRouteImport } from './routes/_app/customers/$customerId';
import { Route as AppCustomersCompaniesRouteImport } from './routes/_app/customers/companies';
import { Route as AppCustomersPeopleRouteImport } from './routes/_app/customers/people';
import { Route as AppPlatformIndexRouteImport } from './routes/_app/platform/index';
import { Route as AppPlatformBillingRouteImport } from './routes/_app/platform/billing';
import { Route as AppPlatformPricingRouteImport } from './routes/_app/platform/pricing';
import { Route as AppPosIndexRouteImport } from './routes/_app/pos/index';
import { Route as AppPosCatalogRouteImport } from './routes/_app/pos/catalog';
import { Route as AppPosKitchenRouteImport } from './routes/_app/pos/kitchen';
import { Route as AppPosSettingsRouteImport } from './routes/_app/pos/settings';
import { Route as AppPosTabsRouteImport } from './routes/_app/pos/tabs';
import { Route as AppReportsIndexRouteImport } from './routes/_app/reports/index';
import { Route as AppReportsKindRouteImport } from './routes/_app/reports/$kind';
import { Route as AppReservationsIndexRouteImport } from './routes/_app/reservations/index';
import { Route as AppReservationsReservationIdRouteImport } from './routes/_app/reservations/$reservationId';
import { Route as AppReservationsNewRouteImport } from './routes/_app/reservations/new';
import { Route as AppResourcesIndexRouteImport } from './routes/_app/resources/index';
import { Route as AppResourcesResourceIdRouteImport } from './routes/_app/resources/$resourceId';
import { Route as AppResourcesAvailabilityRouteImport } from './routes/_app/resources/availability';
import { Route as AppResourcesMaintenanceRouteImport } from './routes/_app/resources/maintenance';
import { Route as AppRestaurantTablesRouteImport } from './routes/_app/restaurant/tables';
import { Route as AppStockIndexRouteImport } from './routes/_app/stock/index';
import { Route as AppStockCountsRouteImport } from './routes/_app/stock/counts';
import { Route as AppStockItemsRouteImport } from './routes/_app/stock/items';
import { Route as AppStockMovementsRouteImport } from './routes/_app/stock/movements';
import { Route as AppStockPurchasesRouteImport } from './routes/_app/stock/purchases';
import { Route as AppTodayArrivalsRouteImport } from './routes/_app/today/arrivals';
import { Route as AppTodayDeparturesRouteImport } from './routes/_app/today/departures';
import { Route as AppTodayHousekeepingRouteImport } from './routes/_app/today/housekeeping';
import { Route as AppAdminUsersIndexRouteImport } from './routes/_app/admin/users/index';
import { Route as AppAdminUsersUserIdRouteImport } from './routes/_app/admin/users/$userId';
import { Route as AppBillingCashIndexRouteImport } from './routes/_app/billing/cash/index';
import { Route as AppBillingCashSessionIdRouteImport } from './routes/_app/billing/cash/$sessionId';
import { Route as AppBillingCreditNotesIndexRouteImport } from './routes/_app/billing/credit-notes/index';
import { Route as AppBillingCreditNotesCreditNoteIdRouteImport } from './routes/_app/billing/credit-notes/$creditNoteId';
import { Route as AppBillingInvoicesIndexRouteImport } from './routes/_app/billing/invoices/index';
import { Route as AppBillingInvoicesInvoiceIdRouteImport } from './routes/_app/billing/invoices/$invoiceId';
import { Route as AppBillingPaymentsIndexRouteImport } from './routes/_app/billing/payments/index';
import { Route as AppBillingPaymentsPaymentIdRouteImport } from './routes/_app/billing/payments/$paymentId';
import { Route as AppBillingProformasIndexRouteImport } from './routes/_app/billing/proformas/index';
import { Route as AppBillingProformasProformaIdRouteImport } from './routes/_app/billing/proformas/$proformaId';
import { Route as AppCrmCustomersIndexRouteImport } from './routes/_app/crm/customers/index';
import { Route as AppCrmCustomersCustomerIdRouteImport } from './routes/_app/crm/customers/$customerId';
import { Route as AppFinanceExpensesIndexRouteImport } from './routes/_app/finance/expenses/index';
import { Route as AppFinanceExpensesExpenseIdRouteImport } from './routes/_app/finance/expenses/$expenseId';
import { Route as AppPlatformTenantsIndexRouteImport } from './routes/_app/platform/tenants/index';
import { Route as AppPlatformTenantsTenantIdRouteImport } from './routes/_app/platform/tenants/$tenantId';
import { Route as AppPosOrdersIndexRouteImport } from './routes/_app/pos/orders/index';
import { Route as AppPosOrdersOrderIdRouteImport } from './routes/_app/pos/orders/$orderId';
import { Route as AppReservationsReservationIdCheckInRouteImport } from './routes/_app/reservations/$reservationId_.check-in';

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any);
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any);
const InvitationRoute = InvitationRouteImport.update({
  id: '/invitation',
  path: '/invitation',
  getParentRoute: () => rootRouteImport,
} as any);
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any);
const ResetRoute = ResetRouteImport.update({
  id: '/reset',
  path: '/reset',
  getParentRoute: () => rootRouteImport,
} as any);
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any);
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any);
const AppCalendarRoute = AppCalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => AppRoute,
} as any);
const AppMeRoute = AppMeRouteImport.update({
  id: '/me',
  path: '/me',
  getParentRoute: () => AppRoute,
} as any);
const AppModuleUnavailableRoute = AppModuleUnavailableRouteImport.update({
  id: '/module-unavailable',
  path: '/module-unavailable',
  getParentRoute: () => AppRoute,
} as any);
const AppSetupRoute = AppSetupRouteImport.update({
  id: '/setup',
  path: '/setup',
  getParentRoute: () => AppRoute,
} as any);
const AppTasksRoute = AppTasksRouteImport.update({
  id: '/tasks',
  path: '/tasks',
  getParentRoute: () => AppRoute,
} as any);
const DevUiRoute = DevUiRouteImport.update({
  id: '/dev/ui',
  path: '/dev/ui',
  getParentRoute: () => rootRouteImport,
} as any);
const InviteTokenRoute = InviteTokenRouteImport.update({
  id: '/invite/$token',
  path: '/invite/$token',
  getParentRoute: () => rootRouteImport,
} as any);
const AppAdminAuditRoute = AppAdminAuditRouteImport.update({
  id: '/admin/audit',
  path: '/admin/audit',
  getParentRoute: () => AppRoute,
} as any);
const AppAdminRolesRoute = AppAdminRolesRouteImport.update({
  id: '/admin/roles',
  path: '/admin/roles',
  getParentRoute: () => AppRoute,
} as any);
const AppAdminSettingsRoute = AppAdminSettingsRouteImport.update({
  id: '/admin/settings',
  path: '/admin/settings',
  getParentRoute: () => AppRoute,
} as any);
const AppAdminSupportRoute = AppAdminSupportRouteImport.update({
  id: '/admin/support',
  path: '/admin/support',
  getParentRoute: () => AppRoute,
} as any);
const AppAdminTaxesRoute = AppAdminTaxesRouteImport.update({
  id: '/admin/taxes',
  path: '/admin/taxes',
  getParentRoute: () => AppRoute,
} as any);
const AppAnalyticsIndexRoute = AppAnalyticsIndexRouteImport.update({
  id: '/analytics/',
  path: '/analytics/',
  getParentRoute: () => AppRoute,
} as any);
const AppAnalyticsSalesRoute = AppAnalyticsSalesRouteImport.update({
  id: '/analytics/sales',
  path: '/analytics/sales',
  getParentRoute: () => AppRoute,
} as any);
const AppAnalyticsStockRoute = AppAnalyticsStockRouteImport.update({
  id: '/analytics/stock',
  path: '/analytics/stock',
  getParentRoute: () => AppRoute,
} as any);
const AppCrmIndexRoute = AppCrmIndexRouteImport.update({
  id: '/crm/',
  path: '/crm/',
  getParentRoute: () => AppRoute,
} as any);
const AppCrmDuplicatesRoute = AppCrmDuplicatesRouteImport.update({
  id: '/crm/duplicates',
  path: '/crm/duplicates',
  getParentRoute: () => AppRoute,
} as any);
const AppCrmFollowUpsRoute = AppCrmFollowUpsRouteImport.update({
  id: '/crm/follow-ups',
  path: '/crm/follow-ups',
  getParentRoute: () => AppRoute,
} as any);
const AppCrmLoyaltyRoute = AppCrmLoyaltyRouteImport.update({
  id: '/crm/loyalty',
  path: '/crm/loyalty',
  getParentRoute: () => AppRoute,
} as any);
const AppCrmSegmentsRoute = AppCrmSegmentsRouteImport.update({
  id: '/crm/segments',
  path: '/crm/segments',
  getParentRoute: () => AppRoute,
} as any);
const AppCrmSettingsRoute = AppCrmSettingsRouteImport.update({
  id: '/crm/settings',
  path: '/crm/settings',
  getParentRoute: () => AppRoute,
} as any);
const AppCustomersCustomerIdRoute = AppCustomersCustomerIdRouteImport.update({
  id: '/customers/$customerId',
  path: '/customers/$customerId',
  getParentRoute: () => AppRoute,
} as any);
const AppCustomersCompaniesRoute = AppCustomersCompaniesRouteImport.update({
  id: '/customers/companies',
  path: '/customers/companies',
  getParentRoute: () => AppRoute,
} as any);
const AppCustomersPeopleRoute = AppCustomersPeopleRouteImport.update({
  id: '/customers/people',
  path: '/customers/people',
  getParentRoute: () => AppRoute,
} as any);
const AppPlatformIndexRoute = AppPlatformIndexRouteImport.update({
  id: '/platform/',
  path: '/platform/',
  getParentRoute: () => AppRoute,
} as any);
const AppPlatformBillingRoute = AppPlatformBillingRouteImport.update({
  id: '/platform/billing',
  path: '/platform/billing',
  getParentRoute: () => AppRoute,
} as any);
const AppPlatformPricingRoute = AppPlatformPricingRouteImport.update({
  id: '/platform/pricing',
  path: '/platform/pricing',
  getParentRoute: () => AppRoute,
} as any);
const AppPosIndexRoute = AppPosIndexRouteImport.update({
  id: '/pos/',
  path: '/pos/',
  getParentRoute: () => AppRoute,
} as any);
const AppPosCatalogRoute = AppPosCatalogRouteImport.update({
  id: '/pos/catalog',
  path: '/pos/catalog',
  getParentRoute: () => AppRoute,
} as any);
const AppPosKitchenRoute = AppPosKitchenRouteImport.update({
  id: '/pos/kitchen',
  path: '/pos/kitchen',
  getParentRoute: () => AppRoute,
} as any);
const AppPosSettingsRoute = AppPosSettingsRouteImport.update({
  id: '/pos/settings',
  path: '/pos/settings',
  getParentRoute: () => AppRoute,
} as any);
const AppPosTabsRoute = AppPosTabsRouteImport.update({
  id: '/pos/tabs',
  path: '/pos/tabs',
  getParentRoute: () => AppRoute,
} as any);
const AppReportsIndexRoute = AppReportsIndexRouteImport.update({
  id: '/reports/',
  path: '/reports/',
  getParentRoute: () => AppRoute,
} as any);
const AppReportsKindRoute = AppReportsKindRouteImport.update({
  id: '/reports/$kind',
  path: '/reports/$kind',
  getParentRoute: () => AppRoute,
} as any);
const AppReservationsIndexRoute = AppReservationsIndexRouteImport.update({
  id: '/reservations/',
  path: '/reservations/',
  getParentRoute: () => AppRoute,
} as any);
const AppReservationsReservationIdRoute =
  AppReservationsReservationIdRouteImport.update({
    id: '/reservations/$reservationId',
    path: '/reservations/$reservationId',
    getParentRoute: () => AppRoute,
  } as any);
const AppReservationsNewRoute = AppReservationsNewRouteImport.update({
  id: '/reservations/new',
  path: '/reservations/new',
  getParentRoute: () => AppRoute,
} as any);
const AppResourcesIndexRoute = AppResourcesIndexRouteImport.update({
  id: '/resources/',
  path: '/resources/',
  getParentRoute: () => AppRoute,
} as any);
const AppResourcesResourceIdRoute = AppResourcesResourceIdRouteImport.update({
  id: '/resources/$resourceId',
  path: '/resources/$resourceId',
  getParentRoute: () => AppRoute,
} as any);
const AppResourcesAvailabilityRoute =
  AppResourcesAvailabilityRouteImport.update({
    id: '/resources/availability',
    path: '/resources/availability',
    getParentRoute: () => AppRoute,
  } as any);
const AppResourcesMaintenanceRoute = AppResourcesMaintenanceRouteImport.update({
  id: '/resources/maintenance',
  path: '/resources/maintenance',
  getParentRoute: () => AppRoute,
} as any);
const AppRestaurantTablesRoute = AppRestaurantTablesRouteImport.update({
  id: '/restaurant/tables',
  path: '/restaurant/tables',
  getParentRoute: () => AppRoute,
} as any);
const AppStockIndexRoute = AppStockIndexRouteImport.update({
  id: '/stock/',
  path: '/stock/',
  getParentRoute: () => AppRoute,
} as any);
const AppStockCountsRoute = AppStockCountsRouteImport.update({
  id: '/stock/counts',
  path: '/stock/counts',
  getParentRoute: () => AppRoute,
} as any);
const AppStockItemsRoute = AppStockItemsRouteImport.update({
  id: '/stock/items',
  path: '/stock/items',
  getParentRoute: () => AppRoute,
} as any);
const AppStockMovementsRoute = AppStockMovementsRouteImport.update({
  id: '/stock/movements',
  path: '/stock/movements',
  getParentRoute: () => AppRoute,
} as any);
const AppStockPurchasesRoute = AppStockPurchasesRouteImport.update({
  id: '/stock/purchases',
  path: '/stock/purchases',
  getParentRoute: () => AppRoute,
} as any);
const AppTodayArrivalsRoute = AppTodayArrivalsRouteImport.update({
  id: '/today/arrivals',
  path: '/today/arrivals',
  getParentRoute: () => AppRoute,
} as any);
const AppTodayDeparturesRoute = AppTodayDeparturesRouteImport.update({
  id: '/today/departures',
  path: '/today/departures',
  getParentRoute: () => AppRoute,
} as any);
const AppTodayHousekeepingRoute = AppTodayHousekeepingRouteImport.update({
  id: '/today/housekeeping',
  path: '/today/housekeeping',
  getParentRoute: () => AppRoute,
} as any);
const AppAdminUsersIndexRoute = AppAdminUsersIndexRouteImport.update({
  id: '/admin/users/',
  path: '/admin/users/',
  getParentRoute: () => AppRoute,
} as any);
const AppAdminUsersUserIdRoute = AppAdminUsersUserIdRouteImport.update({
  id: '/admin/users/$userId',
  path: '/admin/users/$userId',
  getParentRoute: () => AppRoute,
} as any);
const AppBillingCashIndexRoute = AppBillingCashIndexRouteImport.update({
  id: '/billing/cash/',
  path: '/billing/cash/',
  getParentRoute: () => AppRoute,
} as any);
const AppBillingCashSessionIdRoute = AppBillingCashSessionIdRouteImport.update({
  id: '/billing/cash/$sessionId',
  path: '/billing/cash/$sessionId',
  getParentRoute: () => AppRoute,
} as any);
const AppBillingCreditNotesIndexRoute =
  AppBillingCreditNotesIndexRouteImport.update({
    id: '/billing/credit-notes/',
    path: '/billing/credit-notes/',
    getParentRoute: () => AppRoute,
  } as any);
const AppBillingCreditNotesCreditNoteIdRoute =
  AppBillingCreditNotesCreditNoteIdRouteImport.update({
    id: '/billing/credit-notes/$creditNoteId',
    path: '/billing/credit-notes/$creditNoteId',
    getParentRoute: () => AppRoute,
  } as any);
const AppBillingInvoicesIndexRoute = AppBillingInvoicesIndexRouteImport.update({
  id: '/billing/invoices/',
  path: '/billing/invoices/',
  getParentRoute: () => AppRoute,
} as any);
const AppBillingInvoicesInvoiceIdRoute =
  AppBillingInvoicesInvoiceIdRouteImport.update({
    id: '/billing/invoices/$invoiceId',
    path: '/billing/invoices/$invoiceId',
    getParentRoute: () => AppRoute,
  } as any);
const AppBillingPaymentsIndexRoute = AppBillingPaymentsIndexRouteImport.update({
  id: '/billing/payments/',
  path: '/billing/payments/',
  getParentRoute: () => AppRoute,
} as any);
const AppBillingPaymentsPaymentIdRoute =
  AppBillingPaymentsPaymentIdRouteImport.update({
    id: '/billing/payments/$paymentId',
    path: '/billing/payments/$paymentId',
    getParentRoute: () => AppRoute,
  } as any);
const AppBillingProformasIndexRoute =
  AppBillingProformasIndexRouteImport.update({
    id: '/billing/proformas/',
    path: '/billing/proformas/',
    getParentRoute: () => AppRoute,
  } as any);
const AppBillingProformasProformaIdRoute =
  AppBillingProformasProformaIdRouteImport.update({
    id: '/billing/proformas/$proformaId',
    path: '/billing/proformas/$proformaId',
    getParentRoute: () => AppRoute,
  } as any);
const AppCrmCustomersIndexRoute = AppCrmCustomersIndexRouteImport.update({
  id: '/crm/customers/',
  path: '/crm/customers/',
  getParentRoute: () => AppRoute,
} as any);
const AppCrmCustomersCustomerIdRoute =
  AppCrmCustomersCustomerIdRouteImport.update({
    id: '/crm/customers/$customerId',
    path: '/crm/customers/$customerId',
    getParentRoute: () => AppRoute,
  } as any);
const AppFinanceExpensesIndexRoute = AppFinanceExpensesIndexRouteImport.update({
  id: '/finance/expenses/',
  path: '/finance/expenses/',
  getParentRoute: () => AppRoute,
} as any);
const AppFinanceExpensesExpenseIdRoute =
  AppFinanceExpensesExpenseIdRouteImport.update({
    id: '/finance/expenses/$expenseId',
    path: '/finance/expenses/$expenseId',
    getParentRoute: () => AppRoute,
  } as any);
const AppPlatformTenantsIndexRoute = AppPlatformTenantsIndexRouteImport.update({
  id: '/platform/tenants/',
  path: '/platform/tenants/',
  getParentRoute: () => AppRoute,
} as any);
const AppPlatformTenantsTenantIdRoute =
  AppPlatformTenantsTenantIdRouteImport.update({
    id: '/platform/tenants/$tenantId',
    path: '/platform/tenants/$tenantId',
    getParentRoute: () => AppRoute,
  } as any);
const AppPosOrdersIndexRoute = AppPosOrdersIndexRouteImport.update({
  id: '/pos/orders/',
  path: '/pos/orders/',
  getParentRoute: () => AppRoute,
} as any);
const AppPosOrdersOrderIdRoute = AppPosOrdersOrderIdRouteImport.update({
  id: '/pos/orders/$orderId',
  path: '/pos/orders/$orderId',
  getParentRoute: () => AppRoute,
} as any);
const AppReservationsReservationIdCheckInRoute =
  AppReservationsReservationIdCheckInRouteImport.update({
    id: '/reservations/$reservationId_/check-in',
    path: '/reservations/$reservationId/check-in',
    getParentRoute: () => AppRoute,
  } as any);

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute;
  '/forgot-password': typeof ForgotPasswordRoute;
  '/invitation': typeof InvitationRoute;
  '/login': typeof LoginRoute;
  '/reset': typeof ResetRoute;
  '/reset-password': typeof ResetPasswordRoute;
  '/calendar': typeof AppCalendarRoute;
  '/me': typeof AppMeRoute;
  '/module-unavailable': typeof AppModuleUnavailableRoute;
  '/setup': typeof AppSetupRoute;
  '/tasks': typeof AppTasksRoute;
  '/dev/ui': typeof DevUiRoute;
  '/invite/$token': typeof InviteTokenRoute;
  '/admin/audit': typeof AppAdminAuditRoute;
  '/admin/roles': typeof AppAdminRolesRoute;
  '/admin/settings': typeof AppAdminSettingsRoute;
  '/admin/support': typeof AppAdminSupportRoute;
  '/admin/taxes': typeof AppAdminTaxesRoute;
  '/analytics/sales': typeof AppAnalyticsSalesRoute;
  '/analytics/stock': typeof AppAnalyticsStockRoute;
  '/crm/duplicates': typeof AppCrmDuplicatesRoute;
  '/crm/follow-ups': typeof AppCrmFollowUpsRoute;
  '/crm/loyalty': typeof AppCrmLoyaltyRoute;
  '/crm/segments': typeof AppCrmSegmentsRoute;
  '/crm/settings': typeof AppCrmSettingsRoute;
  '/customers/$customerId': typeof AppCustomersCustomerIdRoute;
  '/customers/companies': typeof AppCustomersCompaniesRoute;
  '/customers/people': typeof AppCustomersPeopleRoute;
  '/platform/billing': typeof AppPlatformBillingRoute;
  '/platform/pricing': typeof AppPlatformPricingRoute;
  '/pos/catalog': typeof AppPosCatalogRoute;
  '/pos/kitchen': typeof AppPosKitchenRoute;
  '/pos/settings': typeof AppPosSettingsRoute;
  '/pos/tabs': typeof AppPosTabsRoute;
  '/reports/$kind': typeof AppReportsKindRoute;
  '/reservations/$reservationId': typeof AppReservationsReservationIdRoute;
  '/reservations/new': typeof AppReservationsNewRoute;
  '/resources/$resourceId': typeof AppResourcesResourceIdRoute;
  '/resources/availability': typeof AppResourcesAvailabilityRoute;
  '/resources/maintenance': typeof AppResourcesMaintenanceRoute;
  '/restaurant/tables': typeof AppRestaurantTablesRoute;
  '/stock/counts': typeof AppStockCountsRoute;
  '/stock/items': typeof AppStockItemsRoute;
  '/stock/movements': typeof AppStockMovementsRoute;
  '/stock/purchases': typeof AppStockPurchasesRoute;
  '/today/arrivals': typeof AppTodayArrivalsRoute;
  '/today/departures': typeof AppTodayDeparturesRoute;
  '/today/housekeeping': typeof AppTodayHousekeepingRoute;
  '/analytics/': typeof AppAnalyticsIndexRoute;
  '/crm/': typeof AppCrmIndexRoute;
  '/platform/': typeof AppPlatformIndexRoute;
  '/pos/': typeof AppPosIndexRoute;
  '/reports/': typeof AppReportsIndexRoute;
  '/reservations/': typeof AppReservationsIndexRoute;
  '/resources/': typeof AppResourcesIndexRoute;
  '/stock/': typeof AppStockIndexRoute;
  '/admin/users/$userId': typeof AppAdminUsersUserIdRoute;
  '/billing/cash/$sessionId': typeof AppBillingCashSessionIdRoute;
  '/billing/credit-notes/$creditNoteId': typeof AppBillingCreditNotesCreditNoteIdRoute;
  '/billing/invoices/$invoiceId': typeof AppBillingInvoicesInvoiceIdRoute;
  '/billing/payments/$paymentId': typeof AppBillingPaymentsPaymentIdRoute;
  '/billing/proformas/$proformaId': typeof AppBillingProformasProformaIdRoute;
  '/crm/customers/$customerId': typeof AppCrmCustomersCustomerIdRoute;
  '/finance/expenses/$expenseId': typeof AppFinanceExpensesExpenseIdRoute;
  '/platform/tenants/$tenantId': typeof AppPlatformTenantsTenantIdRoute;
  '/pos/orders/$orderId': typeof AppPosOrdersOrderIdRoute;
  '/reservations/$reservationId/check-in': typeof AppReservationsReservationIdCheckInRoute;
  '/admin/users/': typeof AppAdminUsersIndexRoute;
  '/billing/cash/': typeof AppBillingCashIndexRoute;
  '/billing/credit-notes/': typeof AppBillingCreditNotesIndexRoute;
  '/billing/invoices/': typeof AppBillingInvoicesIndexRoute;
  '/billing/payments/': typeof AppBillingPaymentsIndexRoute;
  '/billing/proformas/': typeof AppBillingProformasIndexRoute;
  '/crm/customers/': typeof AppCrmCustomersIndexRoute;
  '/finance/expenses/': typeof AppFinanceExpensesIndexRoute;
  '/platform/tenants/': typeof AppPlatformTenantsIndexRoute;
  '/pos/orders/': typeof AppPosOrdersIndexRoute;
}
export interface FileRoutesByTo {
  '/forgot-password': typeof ForgotPasswordRoute;
  '/invitation': typeof InvitationRoute;
  '/login': typeof LoginRoute;
  '/reset': typeof ResetRoute;
  '/reset-password': typeof ResetPasswordRoute;
  '/calendar': typeof AppCalendarRoute;
  '/me': typeof AppMeRoute;
  '/module-unavailable': typeof AppModuleUnavailableRoute;
  '/setup': typeof AppSetupRoute;
  '/tasks': typeof AppTasksRoute;
  '/dev/ui': typeof DevUiRoute;
  '/invite/$token': typeof InviteTokenRoute;
  '/': typeof AppIndexRoute;
  '/admin/audit': typeof AppAdminAuditRoute;
  '/admin/roles': typeof AppAdminRolesRoute;
  '/admin/settings': typeof AppAdminSettingsRoute;
  '/admin/support': typeof AppAdminSupportRoute;
  '/admin/taxes': typeof AppAdminTaxesRoute;
  '/analytics/sales': typeof AppAnalyticsSalesRoute;
  '/analytics/stock': typeof AppAnalyticsStockRoute;
  '/crm/duplicates': typeof AppCrmDuplicatesRoute;
  '/crm/follow-ups': typeof AppCrmFollowUpsRoute;
  '/crm/loyalty': typeof AppCrmLoyaltyRoute;
  '/crm/segments': typeof AppCrmSegmentsRoute;
  '/crm/settings': typeof AppCrmSettingsRoute;
  '/customers/$customerId': typeof AppCustomersCustomerIdRoute;
  '/customers/companies': typeof AppCustomersCompaniesRoute;
  '/customers/people': typeof AppCustomersPeopleRoute;
  '/platform/billing': typeof AppPlatformBillingRoute;
  '/platform/pricing': typeof AppPlatformPricingRoute;
  '/pos/catalog': typeof AppPosCatalogRoute;
  '/pos/kitchen': typeof AppPosKitchenRoute;
  '/pos/settings': typeof AppPosSettingsRoute;
  '/pos/tabs': typeof AppPosTabsRoute;
  '/reports/$kind': typeof AppReportsKindRoute;
  '/reservations/$reservationId': typeof AppReservationsReservationIdRoute;
  '/reservations/new': typeof AppReservationsNewRoute;
  '/resources/$resourceId': typeof AppResourcesResourceIdRoute;
  '/resources/availability': typeof AppResourcesAvailabilityRoute;
  '/resources/maintenance': typeof AppResourcesMaintenanceRoute;
  '/restaurant/tables': typeof AppRestaurantTablesRoute;
  '/stock/counts': typeof AppStockCountsRoute;
  '/stock/items': typeof AppStockItemsRoute;
  '/stock/movements': typeof AppStockMovementsRoute;
  '/stock/purchases': typeof AppStockPurchasesRoute;
  '/today/arrivals': typeof AppTodayArrivalsRoute;
  '/today/departures': typeof AppTodayDeparturesRoute;
  '/today/housekeeping': typeof AppTodayHousekeepingRoute;
  '/analytics': typeof AppAnalyticsIndexRoute;
  '/crm': typeof AppCrmIndexRoute;
  '/platform': typeof AppPlatformIndexRoute;
  '/pos': typeof AppPosIndexRoute;
  '/reports': typeof AppReportsIndexRoute;
  '/reservations': typeof AppReservationsIndexRoute;
  '/resources': typeof AppResourcesIndexRoute;
  '/stock': typeof AppStockIndexRoute;
  '/admin/users/$userId': typeof AppAdminUsersUserIdRoute;
  '/billing/cash/$sessionId': typeof AppBillingCashSessionIdRoute;
  '/billing/credit-notes/$creditNoteId': typeof AppBillingCreditNotesCreditNoteIdRoute;
  '/billing/invoices/$invoiceId': typeof AppBillingInvoicesInvoiceIdRoute;
  '/billing/payments/$paymentId': typeof AppBillingPaymentsPaymentIdRoute;
  '/billing/proformas/$proformaId': typeof AppBillingProformasProformaIdRoute;
  '/crm/customers/$customerId': typeof AppCrmCustomersCustomerIdRoute;
  '/finance/expenses/$expenseId': typeof AppFinanceExpensesExpenseIdRoute;
  '/platform/tenants/$tenantId': typeof AppPlatformTenantsTenantIdRoute;
  '/pos/orders/$orderId': typeof AppPosOrdersOrderIdRoute;
  '/reservations/$reservationId/check-in': typeof AppReservationsReservationIdCheckInRoute;
  '/admin/users': typeof AppAdminUsersIndexRoute;
  '/billing/cash': typeof AppBillingCashIndexRoute;
  '/billing/credit-notes': typeof AppBillingCreditNotesIndexRoute;
  '/billing/invoices': typeof AppBillingInvoicesIndexRoute;
  '/billing/payments': typeof AppBillingPaymentsIndexRoute;
  '/billing/proformas': typeof AppBillingProformasIndexRoute;
  '/crm/customers': typeof AppCrmCustomersIndexRoute;
  '/finance/expenses': typeof AppFinanceExpensesIndexRoute;
  '/platform/tenants': typeof AppPlatformTenantsIndexRoute;
  '/pos/orders': typeof AppPosOrdersIndexRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  '/_app': typeof AppRouteWithChildren;
  '/forgot-password': typeof ForgotPasswordRoute;
  '/invitation': typeof InvitationRoute;
  '/login': typeof LoginRoute;
  '/reset': typeof ResetRoute;
  '/reset-password': typeof ResetPasswordRoute;
  '/_app/calendar': typeof AppCalendarRoute;
  '/_app/me': typeof AppMeRoute;
  '/_app/module-unavailable': typeof AppModuleUnavailableRoute;
  '/_app/setup': typeof AppSetupRoute;
  '/_app/tasks': typeof AppTasksRoute;
  '/dev/ui': typeof DevUiRoute;
  '/invite/$token': typeof InviteTokenRoute;
  '/_app/': typeof AppIndexRoute;
  '/_app/admin/audit': typeof AppAdminAuditRoute;
  '/_app/admin/roles': typeof AppAdminRolesRoute;
  '/_app/admin/settings': typeof AppAdminSettingsRoute;
  '/_app/admin/support': typeof AppAdminSupportRoute;
  '/_app/admin/taxes': typeof AppAdminTaxesRoute;
  '/_app/analytics/sales': typeof AppAnalyticsSalesRoute;
  '/_app/analytics/stock': typeof AppAnalyticsStockRoute;
  '/_app/crm/duplicates': typeof AppCrmDuplicatesRoute;
  '/_app/crm/follow-ups': typeof AppCrmFollowUpsRoute;
  '/_app/crm/loyalty': typeof AppCrmLoyaltyRoute;
  '/_app/crm/segments': typeof AppCrmSegmentsRoute;
  '/_app/crm/settings': typeof AppCrmSettingsRoute;
  '/_app/customers/$customerId': typeof AppCustomersCustomerIdRoute;
  '/_app/customers/companies': typeof AppCustomersCompaniesRoute;
  '/_app/customers/people': typeof AppCustomersPeopleRoute;
  '/_app/platform/billing': typeof AppPlatformBillingRoute;
  '/_app/platform/pricing': typeof AppPlatformPricingRoute;
  '/_app/pos/catalog': typeof AppPosCatalogRoute;
  '/_app/pos/kitchen': typeof AppPosKitchenRoute;
  '/_app/pos/settings': typeof AppPosSettingsRoute;
  '/_app/pos/tabs': typeof AppPosTabsRoute;
  '/_app/reports/$kind': typeof AppReportsKindRoute;
  '/_app/reservations/$reservationId': typeof AppReservationsReservationIdRoute;
  '/_app/reservations/new': typeof AppReservationsNewRoute;
  '/_app/resources/$resourceId': typeof AppResourcesResourceIdRoute;
  '/_app/resources/availability': typeof AppResourcesAvailabilityRoute;
  '/_app/resources/maintenance': typeof AppResourcesMaintenanceRoute;
  '/_app/restaurant/tables': typeof AppRestaurantTablesRoute;
  '/_app/stock/counts': typeof AppStockCountsRoute;
  '/_app/stock/items': typeof AppStockItemsRoute;
  '/_app/stock/movements': typeof AppStockMovementsRoute;
  '/_app/stock/purchases': typeof AppStockPurchasesRoute;
  '/_app/today/arrivals': typeof AppTodayArrivalsRoute;
  '/_app/today/departures': typeof AppTodayDeparturesRoute;
  '/_app/today/housekeeping': typeof AppTodayHousekeepingRoute;
  '/_app/analytics/': typeof AppAnalyticsIndexRoute;
  '/_app/crm/': typeof AppCrmIndexRoute;
  '/_app/platform/': typeof AppPlatformIndexRoute;
  '/_app/pos/': typeof AppPosIndexRoute;
  '/_app/reports/': typeof AppReportsIndexRoute;
  '/_app/reservations/': typeof AppReservationsIndexRoute;
  '/_app/resources/': typeof AppResourcesIndexRoute;
  '/_app/stock/': typeof AppStockIndexRoute;
  '/_app/admin/users/$userId': typeof AppAdminUsersUserIdRoute;
  '/_app/billing/cash/$sessionId': typeof AppBillingCashSessionIdRoute;
  '/_app/billing/credit-notes/$creditNoteId': typeof AppBillingCreditNotesCreditNoteIdRoute;
  '/_app/billing/invoices/$invoiceId': typeof AppBillingInvoicesInvoiceIdRoute;
  '/_app/billing/payments/$paymentId': typeof AppBillingPaymentsPaymentIdRoute;
  '/_app/billing/proformas/$proformaId': typeof AppBillingProformasProformaIdRoute;
  '/_app/crm/customers/$customerId': typeof AppCrmCustomersCustomerIdRoute;
  '/_app/finance/expenses/$expenseId': typeof AppFinanceExpensesExpenseIdRoute;
  '/_app/platform/tenants/$tenantId': typeof AppPlatformTenantsTenantIdRoute;
  '/_app/pos/orders/$orderId': typeof AppPosOrdersOrderIdRoute;
  '/_app/reservations/$reservationId_/check-in': typeof AppReservationsReservationIdCheckInRoute;
  '/_app/admin/users/': typeof AppAdminUsersIndexRoute;
  '/_app/billing/cash/': typeof AppBillingCashIndexRoute;
  '/_app/billing/credit-notes/': typeof AppBillingCreditNotesIndexRoute;
  '/_app/billing/invoices/': typeof AppBillingInvoicesIndexRoute;
  '/_app/billing/payments/': typeof AppBillingPaymentsIndexRoute;
  '/_app/billing/proformas/': typeof AppBillingProformasIndexRoute;
  '/_app/crm/customers/': typeof AppCrmCustomersIndexRoute;
  '/_app/finance/expenses/': typeof AppFinanceExpensesIndexRoute;
  '/_app/platform/tenants/': typeof AppPlatformTenantsIndexRoute;
  '/_app/pos/orders/': typeof AppPosOrdersIndexRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/'
    | '/forgot-password'
    | '/invitation'
    | '/login'
    | '/reset'
    | '/reset-password'
    | '/calendar'
    | '/me'
    | '/module-unavailable'
    | '/setup'
    | '/tasks'
    | '/dev/ui'
    | '/invite/$token'
    | '/admin/audit'
    | '/admin/roles'
    | '/admin/settings'
    | '/admin/support'
    | '/admin/taxes'
    | '/analytics/sales'
    | '/analytics/stock'
    | '/crm/duplicates'
    | '/crm/follow-ups'
    | '/crm/loyalty'
    | '/crm/segments'
    | '/crm/settings'
    | '/customers/$customerId'
    | '/customers/companies'
    | '/customers/people'
    | '/platform/billing'
    | '/platform/pricing'
    | '/pos/catalog'
    | '/pos/kitchen'
    | '/pos/settings'
    | '/pos/tabs'
    | '/reports/$kind'
    | '/reservations/$reservationId'
    | '/reservations/new'
    | '/resources/$resourceId'
    | '/resources/availability'
    | '/resources/maintenance'
    | '/restaurant/tables'
    | '/stock/counts'
    | '/stock/items'
    | '/stock/movements'
    | '/stock/purchases'
    | '/today/arrivals'
    | '/today/departures'
    | '/today/housekeeping'
    | '/analytics/'
    | '/crm/'
    | '/platform/'
    | '/pos/'
    | '/reports/'
    | '/reservations/'
    | '/resources/'
    | '/stock/'
    | '/admin/users/$userId'
    | '/billing/cash/$sessionId'
    | '/billing/credit-notes/$creditNoteId'
    | '/billing/invoices/$invoiceId'
    | '/billing/payments/$paymentId'
    | '/billing/proformas/$proformaId'
    | '/crm/customers/$customerId'
    | '/finance/expenses/$expenseId'
    | '/platform/tenants/$tenantId'
    | '/pos/orders/$orderId'
    | '/reservations/$reservationId/check-in'
    | '/admin/users/'
    | '/billing/cash/'
    | '/billing/credit-notes/'
    | '/billing/invoices/'
    | '/billing/payments/'
    | '/billing/proformas/'
    | '/crm/customers/'
    | '/finance/expenses/'
    | '/platform/tenants/'
    | '/pos/orders/';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/forgot-password'
    | '/invitation'
    | '/login'
    | '/reset'
    | '/reset-password'
    | '/calendar'
    | '/me'
    | '/module-unavailable'
    | '/setup'
    | '/tasks'
    | '/dev/ui'
    | '/invite/$token'
    | '/'
    | '/admin/audit'
    | '/admin/roles'
    | '/admin/settings'
    | '/admin/support'
    | '/admin/taxes'
    | '/analytics/sales'
    | '/analytics/stock'
    | '/crm/duplicates'
    | '/crm/follow-ups'
    | '/crm/loyalty'
    | '/crm/segments'
    | '/crm/settings'
    | '/customers/$customerId'
    | '/customers/companies'
    | '/customers/people'
    | '/platform/billing'
    | '/platform/pricing'
    | '/pos/catalog'
    | '/pos/kitchen'
    | '/pos/settings'
    | '/pos/tabs'
    | '/reports/$kind'
    | '/reservations/$reservationId'
    | '/reservations/new'
    | '/resources/$resourceId'
    | '/resources/availability'
    | '/resources/maintenance'
    | '/restaurant/tables'
    | '/stock/counts'
    | '/stock/items'
    | '/stock/movements'
    | '/stock/purchases'
    | '/today/arrivals'
    | '/today/departures'
    | '/today/housekeeping'
    | '/analytics'
    | '/crm'
    | '/platform'
    | '/pos'
    | '/reports'
    | '/reservations'
    | '/resources'
    | '/stock'
    | '/admin/users/$userId'
    | '/billing/cash/$sessionId'
    | '/billing/credit-notes/$creditNoteId'
    | '/billing/invoices/$invoiceId'
    | '/billing/payments/$paymentId'
    | '/billing/proformas/$proformaId'
    | '/crm/customers/$customerId'
    | '/finance/expenses/$expenseId'
    | '/platform/tenants/$tenantId'
    | '/pos/orders/$orderId'
    | '/reservations/$reservationId/check-in'
    | '/admin/users'
    | '/billing/cash'
    | '/billing/credit-notes'
    | '/billing/invoices'
    | '/billing/payments'
    | '/billing/proformas'
    | '/crm/customers'
    | '/finance/expenses'
    | '/platform/tenants'
    | '/pos/orders';
  id:
    | '__root__'
    | '/_app'
    | '/forgot-password'
    | '/invitation'
    | '/login'
    | '/reset'
    | '/reset-password'
    | '/_app/calendar'
    | '/_app/me'
    | '/_app/module-unavailable'
    | '/_app/setup'
    | '/_app/tasks'
    | '/dev/ui'
    | '/invite/$token'
    | '/_app/'
    | '/_app/admin/audit'
    | '/_app/admin/roles'
    | '/_app/admin/settings'
    | '/_app/admin/support'
    | '/_app/admin/taxes'
    | '/_app/analytics/sales'
    | '/_app/analytics/stock'
    | '/_app/crm/duplicates'
    | '/_app/crm/follow-ups'
    | '/_app/crm/loyalty'
    | '/_app/crm/segments'
    | '/_app/crm/settings'
    | '/_app/customers/$customerId'
    | '/_app/customers/companies'
    | '/_app/customers/people'
    | '/_app/platform/billing'
    | '/_app/platform/pricing'
    | '/_app/pos/catalog'
    | '/_app/pos/kitchen'
    | '/_app/pos/settings'
    | '/_app/pos/tabs'
    | '/_app/reports/$kind'
    | '/_app/reservations/$reservationId'
    | '/_app/reservations/new'
    | '/_app/resources/$resourceId'
    | '/_app/resources/availability'
    | '/_app/resources/maintenance'
    | '/_app/restaurant/tables'
    | '/_app/stock/counts'
    | '/_app/stock/items'
    | '/_app/stock/movements'
    | '/_app/stock/purchases'
    | '/_app/today/arrivals'
    | '/_app/today/departures'
    | '/_app/today/housekeeping'
    | '/_app/analytics/'
    | '/_app/crm/'
    | '/_app/platform/'
    | '/_app/pos/'
    | '/_app/reports/'
    | '/_app/reservations/'
    | '/_app/resources/'
    | '/_app/stock/'
    | '/_app/admin/users/$userId'
    | '/_app/billing/cash/$sessionId'
    | '/_app/billing/credit-notes/$creditNoteId'
    | '/_app/billing/invoices/$invoiceId'
    | '/_app/billing/payments/$paymentId'
    | '/_app/billing/proformas/$proformaId'
    | '/_app/crm/customers/$customerId'
    | '/_app/finance/expenses/$expenseId'
    | '/_app/platform/tenants/$tenantId'
    | '/_app/pos/orders/$orderId'
    | '/_app/reservations/$reservationId_/check-in'
    | '/_app/admin/users/'
    | '/_app/billing/cash/'
    | '/_app/billing/credit-notes/'
    | '/_app/billing/invoices/'
    | '/_app/billing/payments/'
    | '/_app/billing/proformas/'
    | '/_app/crm/customers/'
    | '/_app/finance/expenses/'
    | '/_app/platform/tenants/'
    | '/_app/pos/orders/';
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren;
  ForgotPasswordRoute: typeof ForgotPasswordRoute;
  InvitationRoute: typeof InvitationRoute;
  LoginRoute: typeof LoginRoute;
  ResetRoute: typeof ResetRoute;
  ResetPasswordRoute: typeof ResetPasswordRoute;
  DevUiRoute: typeof DevUiRoute;
  InviteTokenRoute: typeof InviteTokenRoute;
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app';
      path: '';
      fullPath: '/';
      preLoaderRoute: typeof AppRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/forgot-password': {
      id: '/forgot-password';
      path: '/forgot-password';
      fullPath: '/forgot-password';
      preLoaderRoute: typeof ForgotPasswordRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/invitation': {
      id: '/invitation';
      path: '/invitation';
      fullPath: '/invitation';
      preLoaderRoute: typeof InvitationRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/login': {
      id: '/login';
      path: '/login';
      fullPath: '/login';
      preLoaderRoute: typeof LoginRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/reset': {
      id: '/reset';
      path: '/reset';
      fullPath: '/reset';
      preLoaderRoute: typeof ResetRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/reset-password': {
      id: '/reset-password';
      path: '/reset-password';
      fullPath: '/reset-password';
      preLoaderRoute: typeof ResetPasswordRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/_app/': {
      id: '/_app/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof AppIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/calendar': {
      id: '/_app/calendar';
      path: '/calendar';
      fullPath: '/calendar';
      preLoaderRoute: typeof AppCalendarRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/me': {
      id: '/_app/me';
      path: '/me';
      fullPath: '/me';
      preLoaderRoute: typeof AppMeRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/module-unavailable': {
      id: '/_app/module-unavailable';
      path: '/module-unavailable';
      fullPath: '/module-unavailable';
      preLoaderRoute: typeof AppModuleUnavailableRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/setup': {
      id: '/_app/setup';
      path: '/setup';
      fullPath: '/setup';
      preLoaderRoute: typeof AppSetupRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/tasks': {
      id: '/_app/tasks';
      path: '/tasks';
      fullPath: '/tasks';
      preLoaderRoute: typeof AppTasksRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/dev/ui': {
      id: '/dev/ui';
      path: '/dev/ui';
      fullPath: '/dev/ui';
      preLoaderRoute: typeof DevUiRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/invite/$token': {
      id: '/invite/$token';
      path: '/invite/$token';
      fullPath: '/invite/$token';
      preLoaderRoute: typeof InviteTokenRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/_app/admin/audit': {
      id: '/_app/admin/audit';
      path: '/admin/audit';
      fullPath: '/admin/audit';
      preLoaderRoute: typeof AppAdminAuditRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/admin/roles': {
      id: '/_app/admin/roles';
      path: '/admin/roles';
      fullPath: '/admin/roles';
      preLoaderRoute: typeof AppAdminRolesRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/admin/settings': {
      id: '/_app/admin/settings';
      path: '/admin/settings';
      fullPath: '/admin/settings';
      preLoaderRoute: typeof AppAdminSettingsRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/admin/support': {
      id: '/_app/admin/support';
      path: '/admin/support';
      fullPath: '/admin/support';
      preLoaderRoute: typeof AppAdminSupportRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/admin/taxes': {
      id: '/_app/admin/taxes';
      path: '/admin/taxes';
      fullPath: '/admin/taxes';
      preLoaderRoute: typeof AppAdminTaxesRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/analytics/': {
      id: '/_app/analytics/';
      path: '/analytics';
      fullPath: '/analytics/';
      preLoaderRoute: typeof AppAnalyticsIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/analytics/sales': {
      id: '/_app/analytics/sales';
      path: '/analytics/sales';
      fullPath: '/analytics/sales';
      preLoaderRoute: typeof AppAnalyticsSalesRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/analytics/stock': {
      id: '/_app/analytics/stock';
      path: '/analytics/stock';
      fullPath: '/analytics/stock';
      preLoaderRoute: typeof AppAnalyticsStockRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/crm/': {
      id: '/_app/crm/';
      path: '/crm';
      fullPath: '/crm/';
      preLoaderRoute: typeof AppCrmIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/crm/duplicates': {
      id: '/_app/crm/duplicates';
      path: '/crm/duplicates';
      fullPath: '/crm/duplicates';
      preLoaderRoute: typeof AppCrmDuplicatesRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/crm/follow-ups': {
      id: '/_app/crm/follow-ups';
      path: '/crm/follow-ups';
      fullPath: '/crm/follow-ups';
      preLoaderRoute: typeof AppCrmFollowUpsRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/crm/loyalty': {
      id: '/_app/crm/loyalty';
      path: '/crm/loyalty';
      fullPath: '/crm/loyalty';
      preLoaderRoute: typeof AppCrmLoyaltyRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/crm/segments': {
      id: '/_app/crm/segments';
      path: '/crm/segments';
      fullPath: '/crm/segments';
      preLoaderRoute: typeof AppCrmSegmentsRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/crm/settings': {
      id: '/_app/crm/settings';
      path: '/crm/settings';
      fullPath: '/crm/settings';
      preLoaderRoute: typeof AppCrmSettingsRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/customers/$customerId': {
      id: '/_app/customers/$customerId';
      path: '/customers/$customerId';
      fullPath: '/customers/$customerId';
      preLoaderRoute: typeof AppCustomersCustomerIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/customers/companies': {
      id: '/_app/customers/companies';
      path: '/customers/companies';
      fullPath: '/customers/companies';
      preLoaderRoute: typeof AppCustomersCompaniesRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/customers/people': {
      id: '/_app/customers/people';
      path: '/customers/people';
      fullPath: '/customers/people';
      preLoaderRoute: typeof AppCustomersPeopleRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/platform/': {
      id: '/_app/platform/';
      path: '/platform';
      fullPath: '/platform/';
      preLoaderRoute: typeof AppPlatformIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/platform/billing': {
      id: '/_app/platform/billing';
      path: '/platform/billing';
      fullPath: '/platform/billing';
      preLoaderRoute: typeof AppPlatformBillingRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/platform/pricing': {
      id: '/_app/platform/pricing';
      path: '/platform/pricing';
      fullPath: '/platform/pricing';
      preLoaderRoute: typeof AppPlatformPricingRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/pos/': {
      id: '/_app/pos/';
      path: '/pos';
      fullPath: '/pos/';
      preLoaderRoute: typeof AppPosIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/pos/catalog': {
      id: '/_app/pos/catalog';
      path: '/pos/catalog';
      fullPath: '/pos/catalog';
      preLoaderRoute: typeof AppPosCatalogRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/pos/kitchen': {
      id: '/_app/pos/kitchen';
      path: '/pos/kitchen';
      fullPath: '/pos/kitchen';
      preLoaderRoute: typeof AppPosKitchenRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/pos/settings': {
      id: '/_app/pos/settings';
      path: '/pos/settings';
      fullPath: '/pos/settings';
      preLoaderRoute: typeof AppPosSettingsRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/pos/tabs': {
      id: '/_app/pos/tabs';
      path: '/pos/tabs';
      fullPath: '/pos/tabs';
      preLoaderRoute: typeof AppPosTabsRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/reports/': {
      id: '/_app/reports/';
      path: '/reports';
      fullPath: '/reports/';
      preLoaderRoute: typeof AppReportsIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/reports/$kind': {
      id: '/_app/reports/$kind';
      path: '/reports/$kind';
      fullPath: '/reports/$kind';
      preLoaderRoute: typeof AppReportsKindRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/reservations/': {
      id: '/_app/reservations/';
      path: '/reservations';
      fullPath: '/reservations/';
      preLoaderRoute: typeof AppReservationsIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/reservations/$reservationId': {
      id: '/_app/reservations/$reservationId';
      path: '/reservations/$reservationId';
      fullPath: '/reservations/$reservationId';
      preLoaderRoute: typeof AppReservationsReservationIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/reservations/new': {
      id: '/_app/reservations/new';
      path: '/reservations/new';
      fullPath: '/reservations/new';
      preLoaderRoute: typeof AppReservationsNewRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/resources/': {
      id: '/_app/resources/';
      path: '/resources';
      fullPath: '/resources/';
      preLoaderRoute: typeof AppResourcesIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/resources/$resourceId': {
      id: '/_app/resources/$resourceId';
      path: '/resources/$resourceId';
      fullPath: '/resources/$resourceId';
      preLoaderRoute: typeof AppResourcesResourceIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/resources/availability': {
      id: '/_app/resources/availability';
      path: '/resources/availability';
      fullPath: '/resources/availability';
      preLoaderRoute: typeof AppResourcesAvailabilityRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/resources/maintenance': {
      id: '/_app/resources/maintenance';
      path: '/resources/maintenance';
      fullPath: '/resources/maintenance';
      preLoaderRoute: typeof AppResourcesMaintenanceRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/restaurant/tables': {
      id: '/_app/restaurant/tables';
      path: '/restaurant/tables';
      fullPath: '/restaurant/tables';
      preLoaderRoute: typeof AppRestaurantTablesRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/stock/': {
      id: '/_app/stock/';
      path: '/stock';
      fullPath: '/stock/';
      preLoaderRoute: typeof AppStockIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/stock/counts': {
      id: '/_app/stock/counts';
      path: '/stock/counts';
      fullPath: '/stock/counts';
      preLoaderRoute: typeof AppStockCountsRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/stock/items': {
      id: '/_app/stock/items';
      path: '/stock/items';
      fullPath: '/stock/items';
      preLoaderRoute: typeof AppStockItemsRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/stock/movements': {
      id: '/_app/stock/movements';
      path: '/stock/movements';
      fullPath: '/stock/movements';
      preLoaderRoute: typeof AppStockMovementsRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/stock/purchases': {
      id: '/_app/stock/purchases';
      path: '/stock/purchases';
      fullPath: '/stock/purchases';
      preLoaderRoute: typeof AppStockPurchasesRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/today/arrivals': {
      id: '/_app/today/arrivals';
      path: '/today/arrivals';
      fullPath: '/today/arrivals';
      preLoaderRoute: typeof AppTodayArrivalsRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/today/departures': {
      id: '/_app/today/departures';
      path: '/today/departures';
      fullPath: '/today/departures';
      preLoaderRoute: typeof AppTodayDeparturesRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/today/housekeeping': {
      id: '/_app/today/housekeeping';
      path: '/today/housekeeping';
      fullPath: '/today/housekeeping';
      preLoaderRoute: typeof AppTodayHousekeepingRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/admin/users/': {
      id: '/_app/admin/users/';
      path: '/admin/users';
      fullPath: '/admin/users/';
      preLoaderRoute: typeof AppAdminUsersIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/admin/users/$userId': {
      id: '/_app/admin/users/$userId';
      path: '/admin/users/$userId';
      fullPath: '/admin/users/$userId';
      preLoaderRoute: typeof AppAdminUsersUserIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/billing/cash/': {
      id: '/_app/billing/cash/';
      path: '/billing/cash';
      fullPath: '/billing/cash/';
      preLoaderRoute: typeof AppBillingCashIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/billing/cash/$sessionId': {
      id: '/_app/billing/cash/$sessionId';
      path: '/billing/cash/$sessionId';
      fullPath: '/billing/cash/$sessionId';
      preLoaderRoute: typeof AppBillingCashSessionIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/billing/credit-notes/': {
      id: '/_app/billing/credit-notes/';
      path: '/billing/credit-notes';
      fullPath: '/billing/credit-notes/';
      preLoaderRoute: typeof AppBillingCreditNotesIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/billing/credit-notes/$creditNoteId': {
      id: '/_app/billing/credit-notes/$creditNoteId';
      path: '/billing/credit-notes/$creditNoteId';
      fullPath: '/billing/credit-notes/$creditNoteId';
      preLoaderRoute: typeof AppBillingCreditNotesCreditNoteIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/billing/invoices/': {
      id: '/_app/billing/invoices/';
      path: '/billing/invoices';
      fullPath: '/billing/invoices/';
      preLoaderRoute: typeof AppBillingInvoicesIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/billing/invoices/$invoiceId': {
      id: '/_app/billing/invoices/$invoiceId';
      path: '/billing/invoices/$invoiceId';
      fullPath: '/billing/invoices/$invoiceId';
      preLoaderRoute: typeof AppBillingInvoicesInvoiceIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/billing/payments/': {
      id: '/_app/billing/payments/';
      path: '/billing/payments';
      fullPath: '/billing/payments/';
      preLoaderRoute: typeof AppBillingPaymentsIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/billing/payments/$paymentId': {
      id: '/_app/billing/payments/$paymentId';
      path: '/billing/payments/$paymentId';
      fullPath: '/billing/payments/$paymentId';
      preLoaderRoute: typeof AppBillingPaymentsPaymentIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/billing/proformas/': {
      id: '/_app/billing/proformas/';
      path: '/billing/proformas';
      fullPath: '/billing/proformas/';
      preLoaderRoute: typeof AppBillingProformasIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/billing/proformas/$proformaId': {
      id: '/_app/billing/proformas/$proformaId';
      path: '/billing/proformas/$proformaId';
      fullPath: '/billing/proformas/$proformaId';
      preLoaderRoute: typeof AppBillingProformasProformaIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/crm/customers/': {
      id: '/_app/crm/customers/';
      path: '/crm/customers';
      fullPath: '/crm/customers/';
      preLoaderRoute: typeof AppCrmCustomersIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/crm/customers/$customerId': {
      id: '/_app/crm/customers/$customerId';
      path: '/crm/customers/$customerId';
      fullPath: '/crm/customers/$customerId';
      preLoaderRoute: typeof AppCrmCustomersCustomerIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/finance/expenses/': {
      id: '/_app/finance/expenses/';
      path: '/finance/expenses';
      fullPath: '/finance/expenses/';
      preLoaderRoute: typeof AppFinanceExpensesIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/finance/expenses/$expenseId': {
      id: '/_app/finance/expenses/$expenseId';
      path: '/finance/expenses/$expenseId';
      fullPath: '/finance/expenses/$expenseId';
      preLoaderRoute: typeof AppFinanceExpensesExpenseIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/platform/tenants/': {
      id: '/_app/platform/tenants/';
      path: '/platform/tenants';
      fullPath: '/platform/tenants/';
      preLoaderRoute: typeof AppPlatformTenantsIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/platform/tenants/$tenantId': {
      id: '/_app/platform/tenants/$tenantId';
      path: '/platform/tenants/$tenantId';
      fullPath: '/platform/tenants/$tenantId';
      preLoaderRoute: typeof AppPlatformTenantsTenantIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/pos/orders/': {
      id: '/_app/pos/orders/';
      path: '/pos/orders';
      fullPath: '/pos/orders/';
      preLoaderRoute: typeof AppPosOrdersIndexRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/pos/orders/$orderId': {
      id: '/_app/pos/orders/$orderId';
      path: '/pos/orders/$orderId';
      fullPath: '/pos/orders/$orderId';
      preLoaderRoute: typeof AppPosOrdersOrderIdRouteImport;
      parentRoute: typeof AppRoute;
    };
    '/_app/reservations/$reservationId_/check-in': {
      id: '/_app/reservations/$reservationId_/check-in';
      path: '/reservations/$reservationId/check-in';
      fullPath: '/reservations/$reservationId/check-in';
      preLoaderRoute: typeof AppReservationsReservationIdCheckInRouteImport;
      parentRoute: typeof AppRoute;
    };
  }
}

interface AppRouteChildren {
  AppCalendarRoute: typeof AppCalendarRoute;
  AppMeRoute: typeof AppMeRoute;
  AppModuleUnavailableRoute: typeof AppModuleUnavailableRoute;
  AppSetupRoute: typeof AppSetupRoute;
  AppTasksRoute: typeof AppTasksRoute;
  AppIndexRoute: typeof AppIndexRoute;
  AppAdminAuditRoute: typeof AppAdminAuditRoute;
  AppAdminRolesRoute: typeof AppAdminRolesRoute;
  AppAdminSettingsRoute: typeof AppAdminSettingsRoute;
  AppAdminSupportRoute: typeof AppAdminSupportRoute;
  AppAdminTaxesRoute: typeof AppAdminTaxesRoute;
  AppAnalyticsSalesRoute: typeof AppAnalyticsSalesRoute;
  AppAnalyticsStockRoute: typeof AppAnalyticsStockRoute;
  AppCrmDuplicatesRoute: typeof AppCrmDuplicatesRoute;
  AppCrmFollowUpsRoute: typeof AppCrmFollowUpsRoute;
  AppCrmLoyaltyRoute: typeof AppCrmLoyaltyRoute;
  AppCrmSegmentsRoute: typeof AppCrmSegmentsRoute;
  AppCrmSettingsRoute: typeof AppCrmSettingsRoute;
  AppCustomersCustomerIdRoute: typeof AppCustomersCustomerIdRoute;
  AppCustomersCompaniesRoute: typeof AppCustomersCompaniesRoute;
  AppCustomersPeopleRoute: typeof AppCustomersPeopleRoute;
  AppPlatformBillingRoute: typeof AppPlatformBillingRoute;
  AppPlatformPricingRoute: typeof AppPlatformPricingRoute;
  AppPosCatalogRoute: typeof AppPosCatalogRoute;
  AppPosKitchenRoute: typeof AppPosKitchenRoute;
  AppPosSettingsRoute: typeof AppPosSettingsRoute;
  AppPosTabsRoute: typeof AppPosTabsRoute;
  AppReportsKindRoute: typeof AppReportsKindRoute;
  AppReservationsReservationIdRoute: typeof AppReservationsReservationIdRoute;
  AppReservationsNewRoute: typeof AppReservationsNewRoute;
  AppResourcesResourceIdRoute: typeof AppResourcesResourceIdRoute;
  AppResourcesAvailabilityRoute: typeof AppResourcesAvailabilityRoute;
  AppResourcesMaintenanceRoute: typeof AppResourcesMaintenanceRoute;
  AppRestaurantTablesRoute: typeof AppRestaurantTablesRoute;
  AppStockCountsRoute: typeof AppStockCountsRoute;
  AppStockItemsRoute: typeof AppStockItemsRoute;
  AppStockMovementsRoute: typeof AppStockMovementsRoute;
  AppStockPurchasesRoute: typeof AppStockPurchasesRoute;
  AppTodayArrivalsRoute: typeof AppTodayArrivalsRoute;
  AppTodayDeparturesRoute: typeof AppTodayDeparturesRoute;
  AppTodayHousekeepingRoute: typeof AppTodayHousekeepingRoute;
  AppAnalyticsIndexRoute: typeof AppAnalyticsIndexRoute;
  AppCrmIndexRoute: typeof AppCrmIndexRoute;
  AppPlatformIndexRoute: typeof AppPlatformIndexRoute;
  AppPosIndexRoute: typeof AppPosIndexRoute;
  AppReportsIndexRoute: typeof AppReportsIndexRoute;
  AppReservationsIndexRoute: typeof AppReservationsIndexRoute;
  AppResourcesIndexRoute: typeof AppResourcesIndexRoute;
  AppStockIndexRoute: typeof AppStockIndexRoute;
  AppAdminUsersUserIdRoute: typeof AppAdminUsersUserIdRoute;
  AppBillingCashSessionIdRoute: typeof AppBillingCashSessionIdRoute;
  AppBillingCreditNotesCreditNoteIdRoute: typeof AppBillingCreditNotesCreditNoteIdRoute;
  AppBillingInvoicesInvoiceIdRoute: typeof AppBillingInvoicesInvoiceIdRoute;
  AppBillingPaymentsPaymentIdRoute: typeof AppBillingPaymentsPaymentIdRoute;
  AppBillingProformasProformaIdRoute: typeof AppBillingProformasProformaIdRoute;
  AppCrmCustomersCustomerIdRoute: typeof AppCrmCustomersCustomerIdRoute;
  AppFinanceExpensesExpenseIdRoute: typeof AppFinanceExpensesExpenseIdRoute;
  AppPlatformTenantsTenantIdRoute: typeof AppPlatformTenantsTenantIdRoute;
  AppPosOrdersOrderIdRoute: typeof AppPosOrdersOrderIdRoute;
  AppReservationsReservationIdCheckInRoute: typeof AppReservationsReservationIdCheckInRoute;
  AppAdminUsersIndexRoute: typeof AppAdminUsersIndexRoute;
  AppBillingCashIndexRoute: typeof AppBillingCashIndexRoute;
  AppBillingCreditNotesIndexRoute: typeof AppBillingCreditNotesIndexRoute;
  AppBillingInvoicesIndexRoute: typeof AppBillingInvoicesIndexRoute;
  AppBillingPaymentsIndexRoute: typeof AppBillingPaymentsIndexRoute;
  AppBillingProformasIndexRoute: typeof AppBillingProformasIndexRoute;
  AppCrmCustomersIndexRoute: typeof AppCrmCustomersIndexRoute;
  AppFinanceExpensesIndexRoute: typeof AppFinanceExpensesIndexRoute;
  AppPlatformTenantsIndexRoute: typeof AppPlatformTenantsIndexRoute;
  AppPosOrdersIndexRoute: typeof AppPosOrdersIndexRoute;
}

const AppRouteChildren: AppRouteChildren = {
  AppCalendarRoute: AppCalendarRoute,
  AppMeRoute: AppMeRoute,
  AppModuleUnavailableRoute: AppModuleUnavailableRoute,
  AppSetupRoute: AppSetupRoute,
  AppTasksRoute: AppTasksRoute,
  AppIndexRoute: AppIndexRoute,
  AppAdminAuditRoute: AppAdminAuditRoute,
  AppAdminRolesRoute: AppAdminRolesRoute,
  AppAdminSettingsRoute: AppAdminSettingsRoute,
  AppAdminSupportRoute: AppAdminSupportRoute,
  AppAdminTaxesRoute: AppAdminTaxesRoute,
  AppAnalyticsSalesRoute: AppAnalyticsSalesRoute,
  AppAnalyticsStockRoute: AppAnalyticsStockRoute,
  AppCrmDuplicatesRoute: AppCrmDuplicatesRoute,
  AppCrmFollowUpsRoute: AppCrmFollowUpsRoute,
  AppCrmLoyaltyRoute: AppCrmLoyaltyRoute,
  AppCrmSegmentsRoute: AppCrmSegmentsRoute,
  AppCrmSettingsRoute: AppCrmSettingsRoute,
  AppCustomersCustomerIdRoute: AppCustomersCustomerIdRoute,
  AppCustomersCompaniesRoute: AppCustomersCompaniesRoute,
  AppCustomersPeopleRoute: AppCustomersPeopleRoute,
  AppPlatformBillingRoute: AppPlatformBillingRoute,
  AppPlatformPricingRoute: AppPlatformPricingRoute,
  AppPosCatalogRoute: AppPosCatalogRoute,
  AppPosKitchenRoute: AppPosKitchenRoute,
  AppPosSettingsRoute: AppPosSettingsRoute,
  AppPosTabsRoute: AppPosTabsRoute,
  AppReportsKindRoute: AppReportsKindRoute,
  AppReservationsReservationIdRoute: AppReservationsReservationIdRoute,
  AppReservationsNewRoute: AppReservationsNewRoute,
  AppResourcesResourceIdRoute: AppResourcesResourceIdRoute,
  AppResourcesAvailabilityRoute: AppResourcesAvailabilityRoute,
  AppResourcesMaintenanceRoute: AppResourcesMaintenanceRoute,
  AppRestaurantTablesRoute: AppRestaurantTablesRoute,
  AppStockCountsRoute: AppStockCountsRoute,
  AppStockItemsRoute: AppStockItemsRoute,
  AppStockMovementsRoute: AppStockMovementsRoute,
  AppStockPurchasesRoute: AppStockPurchasesRoute,
  AppTodayArrivalsRoute: AppTodayArrivalsRoute,
  AppTodayDeparturesRoute: AppTodayDeparturesRoute,
  AppTodayHousekeepingRoute: AppTodayHousekeepingRoute,
  AppAnalyticsIndexRoute: AppAnalyticsIndexRoute,
  AppCrmIndexRoute: AppCrmIndexRoute,
  AppPlatformIndexRoute: AppPlatformIndexRoute,
  AppPosIndexRoute: AppPosIndexRoute,
  AppReportsIndexRoute: AppReportsIndexRoute,
  AppReservationsIndexRoute: AppReservationsIndexRoute,
  AppResourcesIndexRoute: AppResourcesIndexRoute,
  AppStockIndexRoute: AppStockIndexRoute,
  AppAdminUsersUserIdRoute: AppAdminUsersUserIdRoute,
  AppBillingCashSessionIdRoute: AppBillingCashSessionIdRoute,
  AppBillingCreditNotesCreditNoteIdRoute:
    AppBillingCreditNotesCreditNoteIdRoute,
  AppBillingInvoicesInvoiceIdRoute: AppBillingInvoicesInvoiceIdRoute,
  AppBillingPaymentsPaymentIdRoute: AppBillingPaymentsPaymentIdRoute,
  AppBillingProformasProformaIdRoute: AppBillingProformasProformaIdRoute,
  AppCrmCustomersCustomerIdRoute: AppCrmCustomersCustomerIdRoute,
  AppFinanceExpensesExpenseIdRoute: AppFinanceExpensesExpenseIdRoute,
  AppPlatformTenantsTenantIdRoute: AppPlatformTenantsTenantIdRoute,
  AppPosOrdersOrderIdRoute: AppPosOrdersOrderIdRoute,
  AppReservationsReservationIdCheckInRoute:
    AppReservationsReservationIdCheckInRoute,
  AppAdminUsersIndexRoute: AppAdminUsersIndexRoute,
  AppBillingCashIndexRoute: AppBillingCashIndexRoute,
  AppBillingCreditNotesIndexRoute: AppBillingCreditNotesIndexRoute,
  AppBillingInvoicesIndexRoute: AppBillingInvoicesIndexRoute,
  AppBillingPaymentsIndexRoute: AppBillingPaymentsIndexRoute,
  AppBillingProformasIndexRoute: AppBillingProformasIndexRoute,
  AppCrmCustomersIndexRoute: AppCrmCustomersIndexRoute,
  AppFinanceExpensesIndexRoute: AppFinanceExpensesIndexRoute,
  AppPlatformTenantsIndexRoute: AppPlatformTenantsIndexRoute,
  AppPosOrdersIndexRoute: AppPosOrdersIndexRoute,
};

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren);

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  InvitationRoute: InvitationRoute,
  LoginRoute: LoginRoute,
  ResetRoute: ResetRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  DevUiRoute: DevUiRoute,
  InviteTokenRoute: InviteTokenRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
